"use client"
import { calculateDataUserPayload } from "@/services/Methods/checkoutPayloads";
import { _productPayload } from "@/services/Methods/commonPayload";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { storeAssigned } from "@/services/Methods/normalMethods";
import { CalculateLiteApi } from "@/services/Redux/Reducer/CheckoutSlice";
import _ from "lodash";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";

function withMiniCartHOC(Component, comingForm) {

    const withMiniCartHOComponent = (props) => {
        const { setActiveStep } = props;

        const [openMiniCart, setOpenMiniCart] = useState(false);
        const [addToCartProducts, setAddToCartProduct] = useState({
            normalProducts: [],
        });
        const [ToRunCalcApi, setToRunCalcApi] = useState(false);
        const checkoutRef = useRef(null);
        const dispatch = useDispatch();
        const pathname = usePathname();

        useEffect(() => {
            if (comingForm) {
                const PRODUCTS = localStorageCall().getItem(String(comingForm + 'Products')) || [];
                let PRODUCTS_DATA = PRODUCTS;
                if (comingForm === 'normal') {
                    PRODUCTS_DATA = _.map(_.filter(PRODUCTS, (r) => (r?.frequency !== "member")), (row) => {
                        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                        let UPDATED_PRODUCTS = row;
                        if (_.includes(['distributor'], CUSTOMER_TYPE?.role)) {
                            UPDATED_PRODUCTS = {
                                ...row,
                                normal_autoship: row[`${CUSTOMER_TYPE?.role}_autoship`],
                                normal_oneTime: row[`${CUSTOMER_TYPE?.role}_oneTime`]
                            };
                        }
                        return UPDATED_PRODUCTS;
                    });
                    const MEMBERSHIP = _.filter(PRODUCTS, (r) => (r?.frequency === "member"));
                    PRODUCTS_DATA = [...PRODUCTS_DATA, ...MEMBERSHIP];
                    localStorageCall().setItem(`${comingForm}Products`, JSON.stringify(PRODUCTS_DATA));
                } else {
                    const NORMAL_PRODUCTS = localStorageCall().getItem('normalProducts');
                    PRODUCTS_DATA = _.uniqBy([...PRODUCTS, ...(NORMAL_PRODUCTS?.length > 0) ? NORMAL_PRODUCTS : []], 'id');
                }

                if (PRODUCTS_DATA?.length > 0) {
                    setAddToCartProduct((prv) => ({ ...prv, [comingForm + 'Products']: PRODUCTS_DATA }));
                    if (setActiveStep && (comingForm === 'retail'))
                        setActiveStep(1);
                }
            }
        }, [comingForm]);

        const debouncedApiCall = useRef(_.debounce((PRODUCTS) => {
            const selectedShippingOption = {
                section: 'normal',
                autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
                oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
            };
            const useDefaultAddressOrNot = { bypassOrNot: true, addessData: null };

            let calculteDataUser = calculateDataUserPayload(null, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
            const detailsArray = _productPayload(PRODUCTS);
            calculteDataUser["details"] = detailsArray;
            calculteDataUser['country'] = _.upperCase(storeAssigned());
            calculteDataUser["lastName"] = 'Bhip';
            const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
            calculteDataUser["priceType"] = _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? 2 : 1
            dispatch(CalculateLiteApi(calculteDataUser, (data) => console.log("ErrorData", data)));
            setToRunCalcApi(true);
        }, 2000)).current;

        //minicart or view cart products
        function _minCartAndViewCartQuantityIncDec(id, section) {
            const PRODUCTS = addToCartProducts[comingForm + 'Products'];
            const FINDINDEX_LOCAL = _.findIndex(PRODUCTS, { id: id });
            if (FINDINDEX_LOCAL > -1) {
                PRODUCTS[FINDINDEX_LOCAL]['quantity'] = (section === "sub") ? ((PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 > 0) ? PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 : 1) : PRODUCTS[FINDINDEX_LOCAL]?.quantity + 1;
                localStorageCall().setItem(String(comingForm + 'Products'), JSON.stringify(PRODUCTS));

                const CartData = localStorageCall().getItem(String(comingForm + 'Products'));
                setAddToCartProduct((prv) => ({ ...prv, [comingForm + 'Products']: CartData }));
            }
            // if (_.includes(pathname, 'distributor')) {
            debouncedApiCall(PRODUCTS);
            // }
            checkoutRef?.current?._calculateApiCall();
        }

        function _changeFrequencyOfProducts(id, frequency = "oneTime") {

            let PRODUCTS = addToCartProducts[comingForm + 'Products'];
            const FIND_PRODUCT_INDEX = _.findIndex(PRODUCTS, { id });

            if (FIND_PRODUCT_INDEX > -1) {
                PRODUCTS[FIND_PRODUCT_INDEX] = { ...PRODUCTS[FIND_PRODUCT_INDEX], frequency };
            }
            localStorageCall().setItem(String(comingForm + 'Products'), JSON.stringify(PRODUCTS));
            const CartData = localStorageCall().getItem(String(comingForm + 'Products'));
            setAddToCartProduct((prv) => ({ ...prv, [comingForm + 'Products']: CartData }));
            // setOpenMiniCart(true);
            setToRunCalcApi(true);
            // checkoutRef?.current?._calculateApiCall();
        }

        function _deleteProductFromCart(id) {
            const PRODUCT_DATA = addToCartProducts[comingForm + 'Products'];
            const FINDPRODUCT = _.find(PRODUCT_DATA, { id });

            if (FINDPRODUCT) {
                const REMAIN_DATA = _.reject(PRODUCT_DATA, FINDPRODUCT);
                localStorageCall().setItem(String(comingForm + 'Products'), JSON.stringify(REMAIN_DATA));
                const CartData = localStorageCall().getItem(String(comingForm + 'Products'));
                setAddToCartProduct((prv) => ({ ...prv, [comingForm + 'Products']: CartData }));

                if (CartData?.length > 0) {
                    // if (_.includes(pathname, 'distributor')) {
                    const selectedShippingOption = {
                        section: 'normal',
                        autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
                        oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
                    };
                    const useDefaultAddressOrNot = { bypassOrNot: true, addessData: null };

                    let calculteDataUser = calculateDataUserPayload(null, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
                    const detailsArray = _productPayload(CartData);
                    calculteDataUser["details"] = detailsArray;
                    calculteDataUser['country'] = _.upperCase(storeAssigned());
                    calculteDataUser["lastName"] = 'Bhip';
                    const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                    calculteDataUser["priceType"] = _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? 2 : 1
                    dispatch(CalculateLiteApi(calculteDataUser, (data) => console.log("ErrorData", data)));
                    // }
                    setToRunCalcApi(true);
                }
            }

            const FIND_NORMAL_PRODUCTS = _.find(localStorageCall().getItem('normalProducts') || [], { id });
            if (FIND_NORMAL_PRODUCTS) {
                const REMAIN_DATA = _.reject(localStorageCall().getItem('normalProducts') || [], FIND_NORMAL_PRODUCTS);
                localStorageCall().setItem('normalProducts', JSON.stringify(REMAIN_DATA));
                setAddToCartProduct((prv) => ({ ...prv, ['normalProducts']: REMAIN_DATA }));
                if (REMAIN_DATA?.length > 0) {
                    // if (_.includes(pathname, 'distributor')) {
                    const selectedShippingOption = {
                        section: 'normal',
                        autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
                        oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
                    };
                    const useDefaultAddressOrNot = { bypassOrNot: true, addessData: null };

                    let calculteDataUser = calculateDataUserPayload(null, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
                    const detailsArray = _productPayload(REMAIN_DATA);
                    calculteDataUser["details"] = detailsArray;
                    calculteDataUser['country'] = _.upperCase(storeAssigned());
                    calculteDataUser["lastName"] = 'Bhip';
                    const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                    calculteDataUser["priceType"] = _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? 2 : 1
                    dispatch(CalculateLiteApi(calculteDataUser, (data) => console.log("ErrorData", data)));
                    // }
                    setToRunCalcApi(true);
                }
            }

        }
        function _autoShipCheck() {
            let isAutoship = false;
            if (_.includes(['distributor', 'normal'], comingForm)) {
                isAutoship = _.find(addToCartProducts[comingForm + 'Products'], { frequency: 'autoship' }) ? true : false;
            }
            return isAutoship;
        }

        const subTotal = useMemo(() => {
            if (addToCartProducts[comingForm + 'Products']?.length > 0) {
                return ({
                    productCount: _.map(addToCartProducts[comingForm + 'Products'], 'quantity').reduce((prv, next) => prv + next),
                    productSubTotal: _.map(addToCartProducts[comingForm + 'Products'], (row) => (_autoShipCheck() ? row[comingForm + '_autoship'] : row[comingForm + '_' + row?.frequency]) * +row?.quantity).reduce((prv, next) => prv + next),
                    productCVValue: _.map(addToCartProducts[comingForm + 'Products'], (row) => (_autoShipCheck() ? row['cv' + '_autoship'] : row['cv' + '_' + row?.frequency]) * +row?.quantity).reduce((prv, next) => prv + next),
                })
            }
        }, [addToCartProducts[comingForm + 'Products']]);

        return <Component {...{
            openMiniCart, setOpenMiniCart, addToCartProducts, setAddToCartProduct, subTotal, _autoShipCheck,
            _minCartAndViewCartQuantityIncDec, _deleteProductFromCart, _changeFrequencyOfProducts, checkoutRef, ToRunCalcApi, setToRunCalcApi
        }} {...props} />
    }
    return withMiniCartHOComponent;

}

export default withMiniCartHOC;